module.exports = __webpack_public_path__ + "static/media/doc-icon.4b716e35.svg";